'use client';

import { ReactNode } from 'react';
import { getAppConfig } from '@bts-web/core-app-config';
import { getAssetTradeUrl } from '../../route-builders';
import { UserAccessWithRoleCheck, HyperLinkButtonBase } from '../../common';
import { useModalDrawerContext } from '../../common/components/ModalDrawerContext/ModalDrawerContext';
import { useUserAccessControl } from '../../common/utils/userAccess';

export interface BuySellMoreButtonProps {
  children?: ReactNode;
  assetId: string;
  isSell: boolean;
}

export const BuySellMoreButton = ({
  children,
  assetId,
  isSell,
}: BuySellMoreButtonProps) => {
  const { closeAll } = useModalDrawerContext();

  const { appId } = getAppConfig();

  const { isPepFailed } = useUserAccessControl();

  if (isPepFailed) {
    return null;
  }

  return (
    <UserAccessWithRoleCheck>
      <HyperLinkButtonBase
        to={getAssetTradeUrl(assetId, {
          type: isSell ? 'sell' : 'buy',
          trailingSlash: true,
        })}
        size="large"
        fullWidth
        visual={appId === 4 ? 'accent' : 'primary'}
        onClick={() => {
          closeAll();
        }}
      >
        {children}
      </HyperLinkButtonBase>
    </UserAccessWithRoleCheck>
  );
};
